import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { SearchResultRepository } from '../../services/search-result-repository';
import { SearchResultApi } from '../../apis/search-result-api';
import type { PumPreview, PumJumpSrpData } from '../../types';

@injectable()
export class SearchResultRepositoryImpl implements SearchResultRepository {
    constructor(
        @inject(SearchResultApi) private searchResultApi: SearchResultApi
    ) {
    }

    preview(data: PumPreview): Promise<PumJumpSrpData> {
        const { playbook, queryStructure } = data
        const requestData = {
            playbook,
            q_s: queryStructure,
        }
        return this.searchResultApi.preview(requestData).then(res => {
            return {
                qid: res.qid,
                playbook: res.playbook,
            }
        });
    }
}
